import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Pricing from './pages/Pricing';
import './App.css';
import ShopLogin from './pages/ShopLogin';
import Dashboard from './pages/Shop/Dashboard';
import ShopJobDetails from './pages/Shop/ShopJobDetails';
import HeadOfficePricing from './pages/Shop/HeadOfficePricing';
import HeadOfficeMyPricing from './pages/Shop/HeadOfficeMyPricing';
import ForgotPassword from './pages/ForgotPassword';
import HeadOfficeChangeMyPricing from './pages/Shop/HeadOfficeChangeMyPricing';
import ShopPastJobs from './pages/Shop/ShopPastJobs';
import VerifyPayment from './pages/VerifyPayment';
import Analytics from './pages/Shop/Analytics';
import NotFoundPage from './pages/404';
import GuestRoute from './routes/GuestRoute';
import AddNewService from './pages/Shop/AddNewService';
import ManagerDashboard from './pages/Manager/ManagerDashboard';
import { HelmetProvider } from 'react-helmet-async';
import Contact from './pages/Contact';
import EquipmentRentals from './pages/EquipmentRentals';
import NewHome from './pages/NewHome';
import MarketPlace from './pages/MarketPlace';
import About from './pages/About';
import UploadFiles from './pages/UploadFiles';
import OnBoarding from './pages/OnBoarding';
import Settings from './pages/Shop/Settings';
import SupplierDashboard from './pages/Supplier/SupplierDashboard';
import { AuthProvider } from "./contexts/AuthContext";
import ManagerRoute from './routes/ManagerRoute';
import RestrictedRoute from './routes/RestrictedRoute';
import SupplierEnquiries from './pages/Supplier/SupplierEnquiries';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminViewAllShops from './pages/Admin/AdminViewAllShops';
import SecretMarketPlace from './pages/SecretMarketPlace';
import PolicyPage, { PoliciesIndex } from './pages/Policies';


function App() {
  return (
    <AuthProvider>
      <HelmetProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<NewHome />} />
            <Route path="/marketplace" element={<MarketPlace />} />
            <Route path="/secret-marketplace" element={<SecretMarketPlace />} />
            <Route path="/marketplace/upload" element={<UploadFiles />} />
            <Route path="/onboarding/plan" element={<OnBoarding />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/demo-signup" element={<Navigate to="/onboarding/plan" replace />} />
            <Route path="/register-print-shop" element={<Navigate to="/onboarding/plan" replace />} />
            <Route path="/checkout" element={<Navigate to="/marketplace" replace />} />
            <Route path="/printing-jobs" element={<Navigate to="/marketplace" replace />} />
            <Route path="/custom-quote" element={<Navigate to="/marketplace" replace />} />
            <Route path="/stores" element={<Navigate to="/marketplace" replace />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/compare-prices" element={<Navigate to="/marketplace" replace />} />
            <Route path="/verify-payment" element={<VerifyPayment />} />
            <Route path="/demo-verify-payment" element={<Navigate to="/onboarding/plan" replace />} />
            <Route path="/verify-online-payment" element={<Navigate to="/marketplace" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/policies" element={<PoliciesIndex />} />
            <Route path="/acceptable-use-policy" element={<PolicyPage policyKey="acceptable" />} />
            <Route path="/shipping-policy" element={<PolicyPage policyKey="shipping" />} />
            <Route path="/returns-policy" element={<PolicyPage policyKey="returns" />} />
            <Route path="/equipment-rentals" element={<EquipmentRentals />} />

            <Route element={<GuestRoute />}>
              <Route path="/shop-login" element={<ShopLogin />} />
            </Route>

            {/* Protect shop routes with RestrictedRoute */}
            <Route element={<RestrictedRoute allowedTypes={["printShop"]} />}>
              <Route path="/shop/dashboard" element={<Dashboard />} />


              <Route path="/admin/pricing" element={<HeadOfficePricing />} />
              <Route path="/admin/add-new-service" element={<AddNewService />} />
              <Route path="/admin/my-pricing" element={<HeadOfficeMyPricing />} />
              <Route path="/admin/change-my-pricing" element={<HeadOfficeChangeMyPricing />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["printShop"]} />}>
              <Route path="/shop/job-details" element={<ShopJobDetails />} />
              <Route path="/shop/closed-jobs" element={<ShopPastJobs />} />
              <Route path="/shop/analytics" element={<Analytics />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["supplier", "specialist"]} />}>
              <Route path="/supplier/dashboard" element={<SupplierDashboard />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["supplier", "specialist", "printShop"]} />}>
              <Route path="/supplier/enquiries" element={<SupplierEnquiries />} />
            </Route>


            {/* <Route element={<RestrictedRoute allowedTypes={["printShop"]} />}>
                <Route path="/both/dashboard" element={<BothDashboard />} />

              </Route> */}

            <Route element={<RestrictedRoute allowedTypes={["printShop", "supplier", "specialist"]} />}>
              <Route path="/shop/settings" element={<Settings />} />

            </Route>

            <Route element={<RestrictedRoute allowedTypes={["admin"]} />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/view-all-shops" element={<AdminViewAllShops />} />
            </Route>



            <Route element={<ManagerRoute />}>

              <Route path="/manager/dashboard" element={<ManagerDashboard />} />

            </Route>


            {/* Catch-All Route: Keep this at the bottom */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default App;
